import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppAuthGuard } from '../utils/app.authguard';
import { SingleProductModeGuardService } from '@shared/services/single-product-mode/single-product-mode-guard.service';
import { CanDeactivateGuard } from '../utils/can-deactivate.guard';
import { CanActivatePR } from '../utils/can-activate-pr.guard';
import { SubscriptionTicketComponent } from './product/order-actions/subscription-ticket/subscription-ticket.component';
import { environment } from 'src/environments/environment';

const sceltaDateAbbonamentoRoute: Routes = environment.isSceltaDateAbbonamentoActive ?
  [{
    path: 'scelta-date-abbonamento',
    component: SubscriptionTicketComponent,
    canActivate: [AppAuthGuard],
    data: {
      title: 'select-subscription-ticket'
    }
  }] : [{
    path: 'scelta-date-abbonamento',
    redirectTo: ''
  }];

const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./product/collection/collection-no-sidebar/collection-no-sidebar.component').then(m => m.CollectionNoSidebarComponent),
    canActivate:[SingleProductModeGuardService]
  },
  {
    path: 'evento/:id',
    loadComponent: () => import('./product/product-details/product-view/product-view.component').then(m => m.ProductViewComponent),
    data: {
      productType: "evento",
      title: "event"
    }
  },
  {
    path: 'abbonamento/:id',
    loadComponent: () => import('./product/product-details/product-view/product-view.component').then(m => m.ProductViewComponent),
    data: {
      productType: "abbonamento",
      title: "subscription"
    }
  },
  {
    path: 'i-miei-ordini',
    loadComponent: () => import('./product/my-orders/my-orders.component').then(m => m.MyOrdersComponent),
    canActivate: [AppAuthGuard],
    data: {
      title: "my-orders"
    }
  },
  {
    path: 'i-miei-ordini/:cartId',
    loadComponent: () => import('./product/my-orders/my-orders-details/my-orders-details.component').then(m => m.MyOrdersDetailsComponent),
    canActivate: [AppAuthGuard],
    data: {
      title: "orders"
    }
  },
  {
    path: 'carrello',
    loadComponent: () => import('./product/cart-registry/cart-registry.component').then(m => m.CartRegistryComponent),
    canActivate: [AppAuthGuard],
    data: {
      title: "cart"
    }
  },
  {
    path: 'checkout/:type/:cartId',
    loadComponent: () => import('./product/success/success.component').then(m => m.SuccessComponent),
    canActivate: [AppAuthGuard],
    data: {
      title: "checkout"
    }
  },
  {
    path: 'cambio-nominativo',
    loadComponent: () => import('./product/order-actions/registry-change/registry-change.component').then(m => m.RegistryChangeComponent),
    data: {
      title: "change-registry"
    }
  },
  {
    path: 'cambio-utilizzatore-calcio',
    loadComponent: () => import('./product/order-actions/change-user-request/change-user-request.component').then(m => m.ChangeUserRequestComponent),
    data: {
      title: "change-user"
    }
  },
  {
    path: 'cambio-supporto',
    loadComponent: () => import('./product/order-actions/change-support-request/change-support-request.component').then(m => m.ChangeSupportRequestComponent),
    data: {
      title: "change-support"
    }
  },
  {
    path: 'perfezionamento',
    loadComponent: () => import('./product/order-actions/refinement-request/refinement-request.component').then(m => m.RefinementRequestComponent),
    data: {
      title: "refinement"
    }
  },
  ...sceltaDateAbbonamentoRoute,
  {
    path: 'conversione',
    loadComponent: () => import('./product/order-actions/conversion-request/conversion-request/conversion-request.component').then(m => m.ConversionRequestComponent),
    data: {
      title: "conversion"
    }
  },

  {
    path: 'richiesta-rimessa-in-vendita',
    loadComponent: () => import('./product/order-actions/resale-request/resale-request.component').then(m => m.ResaleRequestComponent),
    data: {
      title: "re-sale"
    }
  },
  {
    path: 'il-mio-profilo',
    loadComponent: () => import('./user/user-profile/user-profile.component').then(m => m.UserProfileComponent),
    canActivate: [AppAuthGuard],
    canDeactivate: [CanDeactivateGuard],
    data: {
      title: "my-profile"
    }
  },
  {
    path: 'registrati',
    loadComponent: () => import('./user/register-page/register-page.component').then(m => m.RegisterPageComponent),
    canActivate: [AppAuthGuard],
    data: {
      isRegisterPage: true,
      title: "register"
    }
  },
  {
    path: 'pr/:tag',
    loadComponent: () => import('./pr/pr-tag-events/pr-tag-events.component').then(m => m.PrTagEventsComponent),
    canActivate: [],
    data: {
      title: "promoter-tag"
    }
  },
  {
    path: "gestisci",
    loadComponent: () => import('./nameless-festival/management/management.component').then(m => m.ManagementComponent),
    canActivate: [AppAuthGuard],
    data: {
      title: "nameless-festival-management",
    },
  },
  {
    path: 'nameless', loadChildren: () => import('./nameless-festival/nameless-festival.module').then(m => m.NamelessFestivalModule),
  }, 
  {
    path: ':walletType/ordine/:cartId',
    loadComponent: () => import('./product/my-orders/my-orders-details/add-to-google/add-to-google.component').then(m => m.AddToGoogleComponent),
    canActivate: [AppAuthGuard],
  },
  {
    path: 'promoter', loadChildren: () => import('./pr/pr.module').then(m => m.PrModule),canActivate:[CanActivatePR]
  },
  { 
    path: 'sala/:siteId/:eventProgramId', 
    loadComponent: () => import('./product-calendar/product-calendar-view/product-calendar-view.component').then(m => m.ProductCalendarViewComponent)
  },
  // {
  //   path: 'user/dashboard',
  //   loadComponent: () => import('./user/user-dashboard/user-dashboard.component').then(m => m.UserDashboardComponent),
  //   canActivate: [AppAuthGuard],
  //   canDeactivate: [CanDeactivateGuard],
  //   data: {
  //     title: "user-dashboard"
  //   }
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AppAuthGuard]
})
export class ShopRoutingModule { }
